import type { DiffLine } from "../types.js";

export function reviewIdsForHunk(
  lines: DiffLine[],
  fileIndex: number,
  hunkIndex: number,
): Array<string | null> {
  let ordinaryGroup = 0;
  let currentOrdinary: string | null = null;

  return lines.map((line) => {
    if (line.kind !== "addition" && line.kind !== "deletion") {
      currentOrdinary = null;
      return null;
    }
    if (line.moveId != null) {
      currentOrdinary = null;
      return `move:${line.moveId}`;
    }
    if (currentOrdinary == null) {
      currentOrdinary = `change:${fileIndex}:${hunkIndex}:${ordinaryGroup}`;
      ordinaryGroup += 1;
    }
    return currentOrdinary;
  });
}

export function reviewSelection(ids: Array<string | null>, reviewed: Set<string>) {
  const uniqueIds = [...new Set(ids.filter((id): id is string => Boolean(id)))];
  const reviewedCount = uniqueIds.filter((id) => reviewed.has(id)).length;
  return {
    ids: uniqueIds,
    reviewedCount,
    allReviewed: uniqueIds.length > 0 && reviewedCount === uniqueIds.length,
  };
}

export function toggleReviewIds(reviewed: Set<string>, ids: Array<string | null>): Set<string> {
  const next = new Set(reviewed);
  const selection = reviewSelection(ids, reviewed);
  selection.ids.forEach((id) => {
    if (selection.allReviewed) next.delete(id);
    else next.add(id);
  });
  return next;
}

export function diffFingerprint(diff: string): string {
  let first = 0x811c9dc5;
  let second = 0x9e3779b9;
  for (let index = 0; index < diff.length; index += 1) {
    const code = diff.charCodeAt(index);
    first = Math.imul(first ^ code, 0x01000193);
    second = Math.imul(second ^ code, 0x85ebca6b);
  }
  return `${diff.length.toString(36)}-${(first >>> 0).toString(36)}-${(second >>> 0).toString(36)}`;
}

export function decodeReviewed(value: string | null): Set<string> {
  if (!value) return new Set();
  try {
    const ids: unknown = JSON.parse(value);
    return Array.isArray(ids)
      ? new Set(ids.filter((id) => typeof id === "string"))
      : new Set();
  } catch {
    return new Set();
  }
}

export function encodeReviewed(reviewed: Set<string>): string {
  return JSON.stringify([...reviewed].sort());
}
